// ButtonChoice.tsx
import React, { useState, useContext } from 'react';
//import SkillButtons from './SkillButtons';
import SkillButtonsAndQuestionGenerator from './SkillButtonsAndQuestionGenerator';
import { Box, Button, Typography, useTheme } from '@mui/material';
import { PromptContext } from '../PromptContext';

type MainMenuProps = {
  demoMode?: boolean;
  demoSkill?: string;
  demoDifficulty?: 'Easy' | 'Medium' | 'Hard';
}

const MainMenu: React.FC<MainMenuProps> = ({ 
  demoMode = false, 
  demoSkill = 'Linear Equations', 
  demoDifficulty = 'Easy' 
}) => {
  const [selectedSubject, setSelectedSubject] = useState<string | null>(
    demoMode ? "Math" : "Reading and Writing"
  );
  const theme = useTheme();
  const subjectList: string[] = ['Reading and Writing', 'Math'];
  const {isSeriesActive, setIsSeriesActive} = useContext(PromptContext)!;

  return (
    <Box sx={{display: 'flex', flexDirection: 'column', gap: 2, p: 1, backgroundColor: 'white'}}>
      
      {!isSeriesActive && !demoMode && (
          <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: {xs: 'column', sm: 'row'}, gap: 2}}>
            <Typography variant="h4" sx={{textAlign: 'center'}}>Select a Subject and Skill: </Typography>
    
            <Box sx={{display: 'flex', gap: 2, flexDirection: 'row', justifyContent: 'space-evenly'}}>
              {subjectList.map((subject) => 
                <Button key={subject} variant={selectedSubject === subject ? 'contained' : 'outlined'}
                onClick={() => setSelectedSubject(subject)}
                sx={{minWidth: 160, height: 48, borderRadius: 2,
                  backgroundColor: selectedSubject === subject ? 'custom.green' : undefined,
                  '&:hover': {
                    backgroundColor: selectedSubject === subject ? 'custom.darkgreen' : undefined,
                  },
                  fontWeight: 'bold'
                }}>
                  {subject}
                </Button>
              )}
            </Box>
        </Box>
      )}
      
      
      {selectedSubject && (
        <SkillButtonsAndQuestionGenerator 
          selectedSubject={selectedSubject}
          demoMode={demoMode}
          demoSkill={demoSkill}
          demoDifficulty={demoDifficulty}
        />
      )}

    </Box>
  );
}; /* the <SkillButtonsAndQuestionGenerator... /> component is the one that actually generates the questions */

export default MainMenu;